// extracted by mini-css-extract-plugin
export default {"label":"CustomCheckbox_label__x380F"};